module.exports = __webpack_public_path__ + "778ef6e4614f1d5447b0274ab1151acb.svg";